import TableInfinite from 'components/table/infinite/InfiniteTable'
import { definitionFields } from './ProductListTable.definitionFields'
import DeleteIcon from '@mui/icons-material/Delete'
import { Theme } from 'theme/theme'
import styled from 'styled-components'
import { ErrorProduct, ProductCreation, ProductCreationWithErrors } from '@Arti-zen/package-backoffice'
import Info from 'components/Info'

type TProps = {
  data: ProductCreationWithErrors[] | ProductCreation[]
  correctProduct: ({
    corrections,
    product,
  }: {
    corrections: Partial<ProductCreation>
    product: ProductCreationWithErrors
    index: number
  }) => void
  openForm: (product: ProductCreation | ProductCreationWithErrors, index: number) => void
  deleteProduct?: (index: number) => void
  onModify: boolean
  replaceAllErrors?: ({
    property,
    getValue,
    conditionInErr,
  }: {
    property: keyof ProductCreation
    getValue: (error: ErrorProduct) => any
    conditionInErr: (err: ErrorProduct) => boolean
  }) => void
  deleteProductsWithErrorsWithoutProp?: (prop: keyof ProductCreation) => void
}

export default function ProductListTable({
  data,
  openForm,
  correctProduct,
  replaceAllErrors,
  onModify,
  deleteProductsWithErrorsWithoutProp,
}: TProps) {
  const getNumberOfErrors = (condition: (err: ErrorProduct) => boolean) => {
    let numberOfErrors = 0
    const products = data as ProductCreationWithErrors[]

    for (let i = 0; i < products.length; i++) {
      const product = products[i]
      if (!Object.hasOwn(product, 'errors')) return 0
      //check if product has error in this property
      const error = product.errors.find((err) => condition(err))
      if (!error) {
        continue
      }
      numberOfErrors++
    }

    return numberOfErrors
  }

  const fields = definitionFields({
    correctProduct,
    openForm,
    hasId: onModify,
    replaceAllErrors,
    getNumberOfErrors,
    deleteProductsWithErrorsWithoutProp,
  })

  return (
    <TableInfinite<ProductCreationWithErrors>
      // @ts-expect-error
      data={data}
      definitionFields={fields}
      isQueriedAllCompleted
    />
  )
}
const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
`

const DeleteButton = styled(DeleteIcon)`
  color: ${Theme.colors.blueArtizen};
  height: 20px;
  cursor: pointer;
  &:hover {
    opacity: 0.6;
  }
`
